import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { PronosticoHidricoInterface, PronosticoHidricoService } from '@/domain/services/PronosticoHidricoService'
import { PronosticoHidricoEstacionState, StoreError } from '@/store/modules/pronostico-hidrico-estacion/types'

const PronosticoHidrico: PronosticoHidricoInterface = new PronosticoHidricoService()

export const actions: ActionTree<PronosticoHidricoEstacionState, RootState> = {
  async getEstacionResumen ({ commit }, { estacionId, periodo }): Promise<any> {
    try {
      const actionResponse = await PronosticoHidrico.getEstacionResumen(estacionId, periodo)
      // TODO: Tener en cuenta que el ID que responde es SIEMPRE 102
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async getLinkDescarga ({ commit }, { estacionId, periodo }): Promise<any> {
    try {
      const actionResponse = await PronosticoHidrico.getLinkDescarga(estacionId, periodo)
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  }
}
